<template>
  <div class="bool-rule">
    <MSelect v-model="localModel" :items="vm.options" textField="text" valueField="value" />
  </div>
</template>
<script setup lang="ts">
import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

//#region General
const props = defineProps<{ value: string }>();
const emit = defineEmits(["input"]);
const { t: $t } = useI18n();
//#endregion

//#region ViewModel
type ViewModel = { options: Array<{ text: string; value: number }> };
const vm = reactive<ViewModel>({
  options: [
    { text: `<${$t("noValue")}>`, value: -1 },
    { text: $t("yes"), value: 1 },
    { text: $t("no"), value: 0 }
  ]
});
//#endregion

//#region LocalModel
const localModel = computed<number>({
  get() {
    switch (props.value) {
      case "true":
        return 1;
      case "false":
        return 0;
      default:
        return -1;
    }
  },
  set(nv) {
    switch (nv) {
      case 1:
        emit("input", "true");
        break;
      case 0:
        emit("input", "false");
        break;
      case -1:
        emit("input", "");
        break;
    }
  }
});
//#endregion
</script>
